import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Programme } from '../../../models/programme.model';
import { Competence } from '../../../models/competence.model';
import { Groupe } from '../../../models/groupe.model';
import { ProgrammesService } from '../../../services/programmes.service';
import { TableauxService } from '../../../services/tableaux.service';
import { Equivalence } from "../../../models/equivalence.model";
import { NewEquivalence } from "../../../models/new-equivalence.model";
import { Tableau } from "../../../models/tableau.model";

@Component({
  selector: 'equivalences-modal-content',
  templateUrl: './equivalences.modal.component.html',
  styleUrls: ['./equivalences.modal.component.scss']
})

export class EquivalencesModalComponent implements OnInit {
  @Input() tableauId: number;
  @Input() fromProgrammeId: number;
  @Input() fromProgrammeName: string;
  @Input() fromProgrammeCode: string;
  @Input() toProgrammeId: number;
  @Input() toProgrammeName: string;
  @Input() toProgrammeCode: string;
  fromCompetences: Array<Competence>;
  toCompetences: Array<Competence>;
  fromSelectedCompetences: Array<number>;
  toSelectedCompetences: Array<number>;
  service: ProgrammesService;
  tableauxService: TableauxService;
  isLoading: boolean;

  constructor(public bsModalRef: BsModalRef,
    service: ProgrammesService,
    tableauxService: TableauxService,) {
    this.service = service;
    this.tableauxService = tableauxService;
  }

  ngOnInit() {
    this.isLoading = true;
    this.service.getCompetencesWithProgrammeId(this.fromProgrammeId).subscribe(x => {
      this.fromCompetences = x;
      this.service.getCompetencesWithProgrammeId(this.toProgrammeId).subscribe(x => {
        this.toCompetences = x;
        // cocher les competences qui sont selectionnees *** ON NE FAIT PAS POUR LE MOMENT
        this.isLoading = false;
      });
    });
    this.fromSelectedCompetences = new Array();
    this.toSelectedCompetences = new Array();
  }

  onFromChange(fromCompetenceId: number, isChecked: boolean) {
    if (isChecked) {
      this.fromSelectedCompetences.push(fromCompetenceId);
    } else {
      const index = this.fromSelectedCompetences.indexOf(fromCompetenceId);
      if (index > -1) {
        this.fromSelectedCompetences.splice(index, 1);
      }
    }
  }

  onToChange(toCompetenceId: number, isChecked: boolean) {
    if (isChecked) {
      this.toSelectedCompetences.push(toCompetenceId);
    } else {
      const index = this.toSelectedCompetences.indexOf(toCompetenceId);
      if (index > -1) {
        this.toSelectedCompetences.splice(index, 1);
      }
    }
  }

  onSubmit() {
    var statut = <HTMLSelectElement><unknown>document.getElementById("statut");
    if (this.fromSelectedCompetences.length == 0 || this.toSelectedCompetences.length == 0 || statut.value == "null") {
      return;
    }
    else {
      // SI LE TABLEAU N'EXISTE PAS... LE CRÉER AVANT!
      if (this.tableauId == -1) {
        var tableau: Tableau = new Tableau();
        tableau.notes = "";
        tableau.fromProgrammeId = this.fromProgrammeId;
        tableau.toProgrammeId = this.toProgrammeId;
        this.tableauxService.createTableau(tableau).subscribe(res => {
          this.tableauxService.getTableau(this.fromProgrammeId, this.toProgrammeId).subscribe(res => {
            tableau = res;
            this.tableauId = tableau.tableauId;
            this.createEquivalence();
          })
        })
      }
      // SI LE TABLEAU EXISTE...
      else {
        this.createEquivalence();
      }
    }
  }

  cancel() {
    this.bsModalRef.hide();
    return;
  }

  createEquivalence() {
    var statut = <HTMLSelectElement><unknown>document.getElementById("statut");
    var newEQ = new NewEquivalence();
    newEQ.tableauId = this.tableauId;
    newEQ.fromCompetences = this.fromSelectedCompetences;
    newEQ.toCompetences = this.toSelectedCompetences;
    newEQ.statut = +statut.value;

    this.tableauxService.createEquivalence(newEQ).subscribe(() => {
      this.isLoading = false;
      this.bsModalRef.hide()
    });
  }

}
